'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarkersReportData = exports.deleteAllClients = exports.generateClientsReportWithFilters = exports.searchClients = exports.getRecentlyViewedClients = exports.findClients = exports.createClient = exports.fetchClientsWithFilters = exports.fetchClientsFilters = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchClientsFilters = exports.fetchClientsFilters = function fetchClientsFilters(f) {
  return (0, _callApi2.default)('GET', '/clients/filters');
};
var fetchClientsWithFilters = exports.fetchClientsWithFilters = function fetchClientsWithFilters(options) {
  return (0, _callApi2.default)('POST', '/clients/filter', options, 'application/json');
};
var createClient = exports.createClient = function createClient(client) {
  return (0, _callApi2.default)('POST', '/clients/create', client, 'application/json');
};
var findClients = exports.findClients = function findClients(name) {
  return (0, _callApi2.default)('POST', '/clients/find', { name: name }, 'application/json');
};
var getRecentlyViewedClients = exports.getRecentlyViewedClients = function getRecentlyViewedClients() {
  return (0, _callApi2.default)('GET', '/clients/recently-viewed', null, 'application/json');
};
var searchClients = exports.searchClients = function searchClients(data) {
  return (0, _callApi2.default)('POST', '/clients/search', { data: data }, 'application/json');
};
var generateClientsReportWithFilters = exports.generateClientsReportWithFilters = function generateClientsReportWithFilters(options) {
  return (0, _callApi2.default)('POST', '/clients/excel_impact_report', options, 'application/json');
};
var deleteAllClients = exports.deleteAllClients = function deleteAllClients(f) {
  return (0, _callApi2.default)('POST', '/clients/delete/all', {}, 'application/json');
};
var getMarkersReportData = exports.getMarkersReportData = function getMarkersReportData(start_date, end_date) {
  return (0, _callApi2.default)('POST', '/markers/marker-report-data', { start_date: start_date, end_date: end_date }, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/clients.js
// module id = 726
// module chunks = 0